import { required, email } from '../utils/validators'

export const state = () => ({
  submitAttempt: false,
  fields: {
    selectedProducts: { required },
    selectedDuration: { required },
    selectedGateway: { required },
    first_name: { required },
    last_name: { required },
    email: { required, email }
  }
})

export const mutations = {
  SET_SUBMIT_ATTEMPT (state, data) {
    state.submitAttempt = data
  }
}

export const getters = {
  $error: (state, getters) => {
    for (let key in getters.fields) {
      if (getters.fields[key].$error) return true
    }
    return false
  },
  fields: (state, getters, rootState) => {
    const results = {}
    for (let field in state.fields) {
      results[field] = {}
      const isUserField = ['first_name', 'last_name', 'email'].includes(field)
      for (let validator in state.fields[field]) {
        // hacky way because of data structure, improve this in the future
        const fieldValue = isUserField ? rootState.checkout['user'][field] : rootState.checkout[field]
        results[field][validator] =  state.fields[field][validator](fieldValue)
        results[field].$invalid = !results[field][validator]
        results[field].$error = state.submitAttempt && results[field].$invalid
      }
    }
    results.idealIssuer = { required: rootState.checkout.selectedGateway.paymentMethod === 'IDEAL' ? required(rootState.checkout.selectedIssuer) : true }
    results.idealIssuer.$invalid = !results.idealIssuer.required
    results.idealIssuer.$error = state.submitAttempt && results.idealIssuer.$invalid
    return results
  },

}

export const actions = {
}

export default {
  namespaced: true,
  state,
  mutations,
  getters,
  actions
}
